export enum LANGUAGES {
  en = 'en-US',
  es = 'es-ES',
  pt = 'pt-PT',
}
